// 国际化简体中文表达部分
export default {
  common: {
    traceabilityDetails: "溯源详情",
    certified: "已认证",
    cancel: "取消",
    confirm: "确认",
    loading: "加载中...",
    yes: "是",
    no: "否",
    language: "语言",
  },
  menu: {
    parkInfo: "园区信息",
    cropInfo: "作物信息",
    videoInfo: "视频信息",
    environmentInfo: "环境信息",
    farmInfo: "农事信息",
    reportInfo: "报告信息",
    harvestInfo: "采摘信息",
  },
  map: {
    baiDu: "百度地图",
    gaoDe: "高德地图(推荐)",
    tencent: "腾讯地图",
  },
  page: {
    parkInfo: {
      parkName: "园区名称",
      parkArea: "园区面积",
      parkAreaUnit: "亩",
      parkUser: "园区负责人",
      parkPhone: "负责人电话",
      parkAddress: "园区地址",
      parkRemark: "园区介绍",
      parkImage: "园区图片",
    },
    cropInfo: {
      cropImage: "种植照片",
      cropVariety: "种植品种",
      cropName: "种植名称",
      buyLink: "购买链接",
      buyLinkDesc: "购买链接描述",
      position: "导航定位",
    },
    videoInfo: {
      videoImage: "视频照片",
      videoName: "视频名称",
      cameraName: "摄像头名称",
      videoStartTime: "开始时间",
      cropName: "种植作物",
      shootNum: "拍摄数量(天)",
      videoType: "视频格式",
      videoRemark: "视频备注",
      isOverVideo: "已生成视频",
    },
    environmentInfo: {
      environmentMetrics: "生产环境指标",
      reportDate: "报表日期",
      minValue: "最小值",
      maxValue: "最大值",
      averageValue: "平均值",
      highestWarningValue: "最高预警值",
      lowestWarningValue: "最低预警值",
      trendChart: "趋势图",
    },
    farmingInfo: {
      farmTitle: "农事作业",
      farmUser: "作业人员",
      farmMaterial: "使用物料",
      targetCrop: "目标作物",
      farmTime: "作业时间",
      farmMachine: "使用农机",
      farmImage: "农事拍照",
      farmContent: "作业内容",
    },
    reportInfo: {
      reportName: "检测报告名称",
      uploadTime: "上传时间",
      reportRemark: "备注信息",
      reportImage: "检测报告照片",
    },
    pickInfo: {
      pickImage: "采摘照片",
      pickUser: "采摘人员",
      pickCrop: "采摘作物",
      pickNumber: "采摘数量(公斤)",
      pickDate: "采摘日期",
      generateTraceability: "生成溯源",
      pickRemark: "备注信息",
    },
  },
  tips: {
    changeLocales: "已切换为: {lang}",
    jumpTipsTitle: "跳转提示",
    jumpTipsContent: "即将跳转到购买链接，是否继续？",
    linkInvalid: "购买链接无效，请联系管理员",
    addressInvalid: "导航定位无效，请联系管理员",
  },
  empty: {
    commonEmpty: "暂无数据",
    noParkImage: "暂无园区图片",
    noOverVideo: "暂无已生成视频",
    noEnvironmentMetrics: "暂无生产环境指标",
    noFarmImage: "暂无农事拍照图片",
    noReportImage: "暂无检测报告照片",
    errorTime: "当前二维码不在可用时间范围内",
    errorNum: "当前二维码使用次数已用尽",
  },
};
